import { Box, CircularProgress } from '@mui/material'

interface LoadingSpinnerProps {
  fullscreen?: boolean
}

export default function LoadingSpinner({ fullscreen }: LoadingSpinnerProps) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height={fullscreen ? '100vh' : '100%'}
      width="100%"
    >
      <CircularProgress size={48} thickness={4} />
    </Box>
  )
}
